function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Helper class for making AJAX requests with event handling using Fetch API.
 * @class
 */

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import ContextualError from '../classes/ContextualError';
import serialize from 'form-serialize';
import Debug from 'scripts/libs/debug';
export default class iamotaAjax {
  /**
   * Helper method to make an AJAX request with event handling using Fetch API.
   *
   * @param {string} method - The HTTP method ('GET', 'POST', etc.).
   * @param {string} url - The URL for the AJAX request.
   * @param {object|string} data - The data to send with the request (for POST/PUT requests).
   * @param {object|string} [events="iamota:ajax"] - The events to trigger and apply filters for.
   *  - If a string is passed, it is used as the base event name for `${events}:before`, `${events}:success`, etc.
   *  - Example object: { before: ['cart:before', 'cart:adding'], success: ['cart:added'], error: ['cart:error', 'cart:add:error'], finally: 'cart:finally' }
   * @param {object} [options={}] - Additional options for the fetch request (e.g., headers).
   * @returns {Promise} - The result of the AJAX request.
   */
  static request(method, url) {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator(function* () {
      var data = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
      var events = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 'iamota:ajax';
      var options = _arguments.length > 4 && _arguments[4] !== undefined ? _arguments[4] : {};
      if (typeof events === 'string') {
        events = {
          before: "".concat(events, ":fetching"),
          success: "".concat(events, ":fetched"),
          error: "".concat(events, ":error"),
          finally: "".concat(events, ":finally")
        };
      }

      // Cast the before event to a single item array if not already an array (so we can append to it easily)
      events.before = [].concat(events.before);
      var defaultOptions = {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      // Standardize FormData as object
      if (data instanceof FormData) {
        data = Object.fromEntries(data);
      }

      // Merge default options with custom ones
      var fetchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);

      // If data is passed, leverage it as query parameters or request body
      data = yield iamotaEventHandler.applyFilters(events.before.map(event => "".concat(event, ":data")), data, {
        url,
        options: fetchOptions
      });
      if (data) {
        switch (method) {
          case 'GET':
          case 'HEAD':
            url = _this.getQueryUrl(url, data);
            break;
          default:
            fetchOptions.body = JSON.stringify(data);
            break;
        }
      }

      // Data Filtering
      url = yield iamotaEventHandler.applyFilters(events.before.map(event => "".concat(event, ":url")), url, {
        data,
        options: fetchOptions
      });
      fetchOptions = yield iamotaEventHandler.applyFilters(events.before.map(event => "".concat(event, ":options")), fetchOptions, {
        url,
        data
      });

      // Fetch
      iamotaEventHandler.trigger(events.before, {
        url,
        data,
        options: fetchOptions
      });
      return fetch(url, fetchOptions).then(response => {
        // Optionally simulate slow network
        var delay = parseInt(localStorage.getItem('iamotaSimulateSlow') || 0, 10);
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(response);
          }, delay);
        });
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (response) {
          // Parse JSON, otherwise return the raw response body
          var data = '';
          var contentType = response.headers.get('content-type');
          if (contentType && (contentType.includes('application/json') || contentType.includes('text/javascript'))) {
            data = yield response.json().catch(() => {
              // Safely try parsing JSON
              throw new ContextualError('Error parsing JSON response', {
                response
              });
            });
          } else {
            data = yield response.text();
          }
          if (!response.ok) {
            throw new ContextualError("Error fetching data (".concat(response.status, ")"), {
              response,
              data
            });
          } else {
            return data;
          }
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).then(responseData => {
        return iamotaEventHandler.applyFilters(events.success, responseData, {
          url,
          data,
          fetchOptions
        });
      }).catch(error => {
        iamotaEventHandler.trigger(events.error, error);
        Debug.error("Error in AJAX Call: ".concat(error.message), {
          error
        });
        throw error;
      }).finally(() => {
        iamotaEventHandler.trigger(events.finally);
      });
    })();
  }

  /**
   * Simplified GET request wrapper.
   *
   * @param {string} url - The URL for the GET request.
   * @param {object|string} [events="iamota:ajax:get"] - The events to trigger and apply filters for.
   * @param {object} [queryData={}] - The data to append as query parameters.
   * @param {object} [options={}] - Additional options for the fetch request (e.g., headers).
   * @returns {Promise} - The result of the GET request.
   */
  static get(url) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'iamota:ajax:get';
    var queryData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var queryUrl = this.getQueryUrl(url, queryData);
    return this.request('GET', queryUrl, {}, events, options);
  }

  /**
   * Simplified POST request wrapper.
   *
   * @param {string} url - The URL for the POST request.
   * @param {object} data - The data to send with the POST request.
   * @param {object|string} [events="iamota:ajax:post"] - The events to trigger and apply filters for.
   * @param {object} [options={}] - Additional options for the fetch request (e.g., headers).
   * @returns {Promise} - The result of the POST request.
   */
  static post(url) {
    var postData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iamota:ajax:post';
    var queryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var queryUrl = this.getQueryUrl(url, queryData);
    return this.request('POST', queryUrl, postData, events, options);
  }

  /**
   * Simplified GraphQL request wrapper.
   *
   * @param {string} url - The URL for the GraphQL request.
   * @param {string} query - The GraphQL query string.
   * @param {object} [variables={}] - The variables for the GraphQL query.
   * @param {object|string} [events="iamota:graphql"] - The events to trigger and apply filters for.
   * @param {object} [options={}] - Additional options for the fetch request (e.g., headers).
   * @returns {Promise<JSON>} - The result of the GraphQL request.
   */
  static graphql(url, query) {
    var variables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var events = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "iamota:ajax:graphql";
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var body = JSON.stringify({
      query,
      variables
    });
    var defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
    var fetchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
    return iamotaAjax.request('POST', url, body, events, fetchOptions);
  }

  /**
   * Generate a URL with query parameters
   * @param {string} url
   * @param {array|URLSearchParams} queryData
   * @returns
   */
  static getQueryUrl(url) {
    var queryData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = new URLSearchParams(queryData).toString();
    if (query) {
      url += url.includes('?') ? "&".concat(query) : "?".concat(query);
    }
    return url;
  }

  /**
   * Convert form data to an object
   * - Often used to make it easier to filter data before sending it in an AJAX request
   * @param {*} form
   * @returns
   */
  static formToObject(form) {
    return serialize(form, {
      hash: true,
      // Convert form data to a JS object
      disabled: false,
      // Ignore disabled form fields
      empty: true // Include empty form fields
    });
  }
}